export const expireToken = (expiry: string) => {
  const expiryTime = new Date(expiry).valueOf();
  const currentTime = new Date().valueOf();
  return currentTime >= expiryTime;
};
